<div class="dashboard-table table-responsive pb-3 px-3">
  <table
    class="table mb-0"
    aria-describedby="Best Performing Lists Table"
    i18n-aria-describedby="
      Dashboard|Dashboard Best Performing Lists Table
      description@@productListBestPerformingListsTableDescription"
  >
    <thead class="dashboard-header">
      <tr>
        <th class="dashboard-header__cover" scope="row"></th>

        <th
          class="dashboard-header__title"
          scope="row"
          i18n="
            Dashboard|Dashboard Best Performing Lists Header
            Title@@productListBestPerformingListsHeaderTitle"
        >
          Title
        </th>

        <th
          class="dashboard-header__author"
          scope="row"
          i18n="
            Dashboard|Dashboard Best Performing Lists Header
            Author@@productListBestPerformingListsHeaderAuthor"
        >
          Author
        </th>

        <th
          class="dashboard-header__views"
          scope="row"
          i18n="
            Dashboard|Dashboard Best Performing Lists Header
            Views@@productListBestPerformingListsHeaderViews"
        >
          Views
        </th>

        <th
          class="dashboard-header__baskets"
          scope="row"
          i18n="
            Dashboard|Dashboard Best Performing Lists Header
            Baskets@@productListBestPerformingListsHeaderBaskets"
        >
          Baskets
        </th>

        <th
          class="dashboard-header__items"
          scope="row"
          i18n="
            Dashboard|Dashboard Best Performing Lists Header
            Items@@productListBestPerformingListsHeaderItems"
        >
          Items
        </th>

        <th
          class="dashboard-header__revenue"
          scope="row"
          i18n="
            Dashboard|Dashboard Best Performing Lists Header
            Revenue@@productListBestPerformingListsHeaderRevenue"
        >
          Revenue
        </th>

        <th
          class="dashboard-header__promotion"
          scope="row"
          i18n="
            Dashboard|Dashboard Best Performing Lists Header
            Promotion@@productListBestPerformingListsHeaderPromotion"
        >
          Promotion
        </th>
      </tr>
    </thead>

    @if (isLoading) {
    <ng-container
      [ngTemplateOutlet]="skeletonsTpl"
      [ngTemplateOutletContext]="{ $implicit: skeletons }"
    ></ng-container>
    } @if (!isLoading) {
    <ng-container
      [ngTemplateOutlet]="bestListsTpl"
      [ngTemplateOutletContext]="{ $implicit: bestLists }"
    ></ng-container>
    }
  </table>
</div>

<ng-template #skeletonsTpl let-skeletons>
  <tbody class="dashboard-body">
    @for (skeleton of skeletons; track skeleton) {
    <tr class="dashboard-item">
      <td class="p-0">
        <div class="position-relative">
          <atx-skeleton-basic
            [borderRadius]="'0.25rem'"
            [width]="'9.125rem'"
            [height]="'5rem'"
          ></atx-skeleton-basic>
        </div>
      </td>
      <td>
        <div>
          <atx-skeleton-basic
            class="mb-1"
            [width]="baseTextWidthSize"
            [height]="baseTextHeightSize"
          ></atx-skeleton-basic>
          <atx-skeleton-basic
            [width]="baseTextWidthSize"
            [height]="baseTextHeightSize"
          ></atx-skeleton-basic>
        </div>
      </td>
      <td>
        <div class="list-author d-flex align-items-center">
          <atx-skeleton-basic
            [circle]="true"
            [width]="'2rem'"
            [height]="'2rem'"
          ></atx-skeleton-basic>
          <div class="ml-3 list-author__info">
            <atx-skeleton-basic
              [width]="baseTextWidthSize"
              [height]="baseTextHeightSize"
            ></atx-skeleton-basic>
            <atx-skeleton-basic
              [width]="baseTextWidthSize"
              [height]="baseTextHeightSize"
            ></atx-skeleton-basic>
          </div>
        </div>
      </td>
      <td>
        <atx-skeleton-basic [height]="baseTextHeightSize"></atx-skeleton-basic>
      </td>
      <td>
        <atx-skeleton-basic [height]="baseTextHeightSize"></atx-skeleton-basic>
      </td>
      <td>
        <atx-skeleton-basic [height]="baseTextHeightSize"></atx-skeleton-basic>
      </td>
      <td>
        <atx-skeleton-basic [height]="baseTextHeightSize"></atx-skeleton-basic>
      </td>
      <td>
        <div class="d-flex dashboard-item__icons justify-content-center pr-2">
          <atx-skeleton-basic
            class="mr-2"
            [width]="baseIconWidthSize"
            [height]="baseIconHeightSize"
          ></atx-skeleton-basic>
          <atx-skeleton-basic
            [width]="baseIconWidthSize"
            [height]="baseIconHeightSize"
          ></atx-skeleton-basic>
        </div>
      </td>
    </tr>
    }
  </tbody>
</ng-template>

<ng-template #bestListsTpl let-lists>
  <tbody class="dashboard-body">
    @for (list of lists; track list) {
    <tr class="dashboard-item">
      <td class="p-0 overflow-hidden">
        <div
          class="list-cover position-relative"
          (click)="redirectToList(list.listInfo.id)"
          (mouseenter)="shouldMediaPlay$$.next(true)"
          (mouseleave)="shouldMediaPlay$$.next(false)"
        >
          <atx-media-preview
            atxCardImage="top"
            class="list-cover__media position-relative cursor-pointer"
            fallbackImageUrl="static/images/placeholder-image.jpg"
            objectFit="cover"
            [media]="list.listInfo?.media"
            [videoAttributes]="{
              controls: false,
              autoplay: false,
              disablePlaceholder: true
            }"
            [activateMedia]="shouldMediaPlay$$ | async"
            [showPreviewMedia]="true"
          >
          </atx-media-preview>
          @if (showHotIconBadges && list.listInfo.id; as listId) {
          <epc-hot-list-indicator
            class="hot-list-indicator"
            [listId]="listId"
          ></epc-hot-list-indicator>
          }
          <div
            class="list-cover__owned-badge position-absolute font-weight-medium justify-content-center align-items-center cursor-pointer"
            [ngClass]="
              list.ownerInfo.externalId === currentUserExternalId
                ? 'd-flex'
                : 'd-none'
            "
          >
            <p
              class="mb-0 font-size-sm"
              i18n="
                Dashboard|Dashboard Best Performing Lists Owned
                List@@productListBestPerformingListsOwnedList"
            >
              Your List
            </p>
          </div>
        </div>
      </td>
      <td>
        <div
          class="list-title cursor-pointer"
          (click)="redirectToList(list.listInfo.id)"
        >
          <h4 class="list-title__header mb-0 font-weight-bold text-truncate">
            {{ list.listInfo?.name }}
          </h4>
          <p
            class="list-title__subheader mb-0 text-muted font-size-sm"
            i18n="
              Dashboard|Dashboard Best Performing Lists Creation
              Date@@productListBestPerformingListsCreationDate"
          >
            {{ list.listInfo.createdAtUtc | date: 'mediumDate' }}
          </p>
        </div>
      </td>
      <td>
        <ng-container
          [ngTemplateOutlet]="authorTpl"
          [ngTemplateOutletContext]="{ $implicit: list.ownerInfo }"
        ></ng-container>
      </td>
      <td
        i18n="
          Dashboard|Dashboard Best Performing Lists Total
          Views@@productListBestPerformingListsTotalViews"
      >
        {{ list.topListInfo.totalViews | number: '1.0-0' }}
      </td>
      <td
        i18n="
          Dashboard|Dashboard Best Performing Lists Total
          Baskets@@productListBestPerformingListsTotalBaskets"
      >
        {{ list.topListInfo.totalBaskets }}
      </td>
      <td
        i18n="
          Dashboard|Dashboard Best Performing Lists Total
          Items@@productListBestPerformingListsTotalItems"
      >
        {{ list.topListInfo.totalItems }}
      </td>
      <td>
        {{
          list.topListInfo.totalRevenue * (exchange?.rate ?? 1)
            | formatPrice: exchange?.currency ?? list.topListInfo.currency
        }}
      </td>
      <td>
        <div class="list-icons">
          @if ( !list.listInfo.recipientsCount && !list.listInfo.newsfeedId &&
          !list.listInfo.lookBookIdsPromotedIn?.length) {
          <p
            class="mb-0 list-icons__unpublished"
            i18n="
              Dashboard|Dashboard Best Performing Lists
              Unpublished@@productListBestPerformingListsUnavailable"
          >
            Unpublished
          </p>
          } @else {
          <div class="d-flex justify-content-center">
            <div>
              @if (list.listInfo.recipientsCount) {
              <fa-icon
                class="list-icons__email"
                [atxTooltip]="
                  getSharedViaEmailText(list.listInfo.recipientsCount)
                "
                [icon]="['fas', 'envelope-open-text']"
              ></fa-icon>
              }
            </div>
            @if ( list.listInfo.newsfeedId ||
            list.listInfo.lookBookIdsPromotedIn?.length ) {
            <div [class.ml-2]="list.listInfo.recipientsCount">
              <fa-icon
                class="list-icons__spotlight"
                [atxTooltip]="promotedViaSpotlightText"
                [icon]="megaphoneShout"
              ></fa-icon>
            </div>
            }
          </div>
          }
        </div>
      </td>
    </tr>
    }
  </tbody>
</ng-template>

<ng-template #authorTpl let-author>
  <div class="list-author d-flex align-items-center">
    <atx-avatar
      class="list-author__image"
      size="s"
      [image]="author.imageLink"
      [fullName]="author.displayName"
    >
    </atx-avatar>

    <div class="ml-3 author">
      <p class="author__name mb-0 font-weight-medium text-truncate">
        {{ author.displayName }}
      </p>
      <div
        class="author__email mb-0 text-muted d-flex cursor-pointer"
        [atxTooltip]="copyEmailText"
        tooltipPlacement="top"
        [cdkCopyToClipboard]="author?.email"
        (cdkCopyToClipboardCopied)="copyToClipboard($event)"
      >
        <span class="text-truncate">{{ author.email }}</span>
      </div>
    </div>
  </div>
</ng-template>
